import ApiService from "./api";

const Video = {
    get(code, params = null) {
        return ApiService.get('video/'+code, {params: params});
    },
};

export default Video;